/* unplugin-vue-components disabled */import { render } from "./FlashBoxRender.vue?vue&type=template&id=5d03f33e&scoped=true"
import script from "./FlashBoxRender.vue?vue&type=script&lang=js"
export * from "./FlashBoxRender.vue?vue&type=script&lang=js"

import "./FlashBoxRender.vue?vue&type=style&index=0&id=5d03f33e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d03f33e"]])

export default __exports__